export const MOBILE_BREAKPOINT = 920

const getAddressMobileFlag = () => {
  if (typeof window === 'undefined') return false

  const url = new URL(window.location.href)
  if (url.searchParams.get('is_mobile') === '1') return true

  const hashQuery = url.hash.includes('?') ? url.hash.slice(url.hash.indexOf('?') + 1) : ''
  return new URLSearchParams(hashQuery).get('is_mobile') === '1'
}

export const shouldUseMobileLayout = (breakpoint = MOBILE_BREAKPOINT) =>
  getAddressMobileFlag() && window.innerWidth <= breakpoint
